// Theme JS — minimal interactivity
(function(){
  // Upload zones — init all [data-upload-zone] elements
  var UPLOAD_ENDPOINT = 'https://upload.sealedlab.de/upload';
  document.querySelectorAll('[data-upload-zone]').forEach(function(zone){
    var zoneId    = zone.id.replace('zone-', '');
    var input     = zone.querySelector('.upload-file-input');
    var previews  = document.getElementById('previews-' + zoneId);
    var status    = document.getElementById('status-' + zoneId);
    var urlsField = document.getElementById('urls-' + zoneId);
    var submitBtn = zone.closest('form') && zone.closest('form').querySelector('[type="submit"]');
    var uploadedUrls = [];
    var uploading = 0;

    function updateField(){ urlsField.value = uploadedUrls.join('\n'); }
    function setStatus(msg, err){ status.textContent = msg; status.className = 'upload-status' + (err ? ' error' : ''); }

    function uploadFile(file){
      if(file.size > 10 * 1024 * 1024){ setStatus('Datei "' + file.name + '" ist zu groß (max. 10 MB).', true); return; }
      uploading++;
      if(submitBtn) submitBtn.disabled = true;

      var tile = document.createElement('div');
      tile.className = 'upload-preview-item';
      var overlay = document.createElement('div');
      overlay.className = 'progress-overlay';
      overlay.textContent = '…';
      tile.appendChild(overlay);
      previews.appendChild(tile);

      var reader = new FileReader();
      reader.onload = function(e){
        var img = document.createElement('img');
        img.src = e.target.result;
        tile.insertBefore(img, overlay);
      };
      reader.readAsDataURL(file);

      var fd = new FormData();
      fd.append('file', file);

      fetch(UPLOAD_ENDPOINT, { method: 'POST', body: fd })
        .then(function(r){ return r.json(); })
        .then(function(data){
          var url = data.url;
          uploadedUrls.push(url);
          updateField();
          tile.removeChild(overlay);
          zone.classList.add('has-files');
          var rm = document.createElement('button');
          rm.className = 'remove-btn'; rm.type = 'button'; rm.textContent = '×';
          rm.setAttribute('aria-label', 'Entfernen');
          rm.addEventListener('click', function(e){
            e.stopPropagation();
            uploadedUrls = uploadedUrls.filter(function(u){ return u !== url; });
            updateField();
            previews.removeChild(tile);
            if(!previews.children.length) zone.classList.remove('has-files');
          });
          tile.appendChild(rm);
          done();
        })
        .catch(function(){
          tile.removeChild(overlay);
          previews.removeChild(tile);
          setStatus('Upload fehlgeschlagen. Bitte erneut versuchen.', true);
          done();
        });
    }

    function done(){
      uploading--;
      if(uploading === 0){
        if(submitBtn) submitBtn.disabled = false;
        setStatus(uploadedUrls.length ? uploadedUrls.length + ' Bild' + (uploadedUrls.length > 1 ? 'er' : '') + ' hochgeladen.' : '');
      }
    }

    function handleFiles(files){ Array.from(files).forEach(uploadFile); }

    zone.addEventListener('click', function(e){
      if(e.target.closest('.remove-btn') || e.target === input) return;
      input.click();
    });
    input.addEventListener('change', function(){ handleFiles(input.files); input.value = ''; });
    zone.addEventListener('dragover', function(e){ e.preventDefault(); zone.classList.add('drag-over'); });
    zone.addEventListener('dragleave', function(){ zone.classList.remove('drag-over'); });
    zone.addEventListener('drop', function(e){ e.preventDefault(); zone.classList.remove('drag-over'); handleFiles(e.dataTransfer.files); });
  });

  // Hamburger menu
  const toggle = document.querySelector('.nav-toggle');
  const header = document.querySelector('#site-header');
  if(toggle && header){
    toggle.addEventListener('click', () => {
      const isOpen = header.classList.toggle('menu-open');
      toggle.setAttribute('aria-expanded', isOpen);
      toggle.setAttribute('aria-label', isOpen ? 'Menü schließen' : 'Menü öffnen');
      document.body.classList.toggle('menu-open', isOpen);
    });

    // Close menu when a nav link is clicked
    header.querySelectorAll('.nav-links a').forEach(link => {
      link.addEventListener('click', () => {
        header.classList.remove('menu-open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Menü öffnen');
        document.body.classList.remove('menu-open');
      });
    });

    // Close on Escape key
    document.addEventListener('keydown', e => {
      if(e.key === 'Escape' && header.classList.contains('menu-open')){
        header.classList.remove('menu-open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Menü öffnen');
        document.body.classList.remove('menu-open');
        toggle.focus();
      }
    });
  }
  // PDP gallery thumb swap
  document.querySelectorAll('[data-thumb]').forEach(t => {
    t.addEventListener('click', () => {
      const main = document.querySelector('[data-main-img]');
      if(!main) return;
      const src = t.getAttribute('data-thumb');
      main.querySelector('img').src = src;
      document.querySelectorAll('[data-thumb]').forEach(x => x.classList.remove('active'));
      t.classList.add('active');
    });
  });

  // Qty stepper
  document.querySelectorAll('[data-qty]').forEach(grp => {
    const input = grp.querySelector('input');
    grp.querySelectorAll('button').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const d = parseInt(btn.dataset.step || '1');
        let v = parseInt(input.value) || 1;
        v = Math.max(1, v + d);
        input.value = v;
      });
    });
  });

  // Mystery pack flip on tap (mobile fallback)
  document.querySelectorAll('.mystery .pack').forEach(p => {
    p.addEventListener('click', () => p.classList.toggle('flipped'));
  });

  // FAQ details (native, no JS needed) — but keep a single-open behaviour optional
  // Uncomment if you want accordion-style one-open behaviour:
  // document.querySelectorAll('.faq-list').forEach(list => {
  //   list.addEventListener('click', e => {
  //     if(e.target.tagName !== 'SUMMARY') return;
  //     list.querySelectorAll('details[open]').forEach(d => {
  //       if(d !== e.target.parentElement) d.removeAttribute('open');
  //     });
  //   });
  // });
})();
